// src/mixins/utilsMixin.js
export const utilsMixin = {
  data() {
    return {
        cities: [
            "Manila",
            "Cebu",
            "Davao",
            "Iloilo",
            "Bacolod",
        ],
        targetDateItems : [
            {
                value : 3,
                text : 'Within 3 Months'
            },
            {
                value : 6,
                text : '3-6 Months'
            },
            {
                value : 12,
                text : '6-12 Months'
            },
            {
                value : 36,
                text : 'More than 1 year away'
            },
            {
                value : 0,
                text : 'Still Exploring'
            }
        ],
        eventTypes: [
            "Church Wedding",
            "Garden Wedding",
            "Beach Wedding",
            "Destination Wedding",
            "Civil Wedding",
            "Intimate Wedding",
            "Luxury Wedding"
        ],
        eventCategoryDetails : {
            1 : {
                name: "Wedding",
                icon: "mdi-ring",
                type : "wedding"
            },
            2 : {
                name: "Travel",
                icon: "mdi-beach",
                type : "travel"
            },
            3 : {
                name: "Celebration",
                icon: "mdi-cake-variant",
                type : "celebration"
            }
        },
        travelInterests : [
            'Honeymoon',
            'Local Tour',
            'International Tour',
            'Cruise',
            'Staycation',
            'Luxury Resort',
            'Adventure Travel',
            'Family Vacation',
            'Incentive Travel',
            'Team Building',
        ],
        celebrationTypes : [
            'Birthday',
            'Anniversary',
            'Corporate Event',
            'Product Launch',
            'Gala Night',
            'Team Building',
            'Reunion',
            'Debut',
            'Holiday Party',
            'Other',
        ],
        budgetRanges : [
            'Below ₱100,000',
            '₱100,000 - ₱300,000',
            '₱300,000 - ₱500,000',
            '₱500,000 - ₱1M',
            '₱1M+',
        ]
    }
  },
  methods: {
    getCategoryOptions(id) {
        let type = this.eventCategoryDetails[id]?.type || null;
        let options = {
            "wedding" : {
                name : "Wedding",
                icon : "mdi-ring",
                type : "wedding",
                remarks : "Anything specific you're looking for in your wedding? (optional)",
                options : {
                    column1 : [
                        {
                            label : "Venue",
                            value : "Venue",
                        },
                        {
                            label : "Catering",
                            value : "Catering",
                        },
                        {
                            label : "Photography",
                            value : "Photography",
                        },
                        {
                            label : "Videography",
                            value : "Videography",
                        },
                        {
                            label : "Bridal Gown",
                            value : "Bridal Gown",
                        },
                        {
                            label : "Suit/Tuxedo",
                            value : "Suit/Tuxedo",
                        },
                        {
                            label : "Hair & Makeup",
                            value : "Hair & Makeup",
                        },
                        {
                            label : "Event Stylist",
                            value : "Event Stylist",
                        },
                        {
                            label : "Wedding Coordinator",
                            value : "Wedding Coordinator",
                        },
                        {
                            label : "Invitations",
                            value : "Invitations",
                        },
                    ],
                    column2 : [
                        {
                            label : "Wedding Rings",
                            value : "Wedding Rings",
                        },
                        {
                            label : "Souvenirs",
                            value : "Souvenirs",
                        },
                        {
                            label : "Photobooth",
                            value : "Photobooth",
                        },
                        {
                            label : "Mobile Bar",
                            value : "Mobile Bar",
                        },
                        {
                            label : "Wedding Cake",
                            value : "Wedding Cake",
                        },
                        {
                            label : "Live Band/DJ",
                            value : "Live Band/DJ",
                        },
                        {
                            label : "Lights and Sounds",
                            value : "Lights and Sounds",
                        },
                        {
                            label : "Honeymoon Planning",
                            value : "Honeymoon Planning",
                        },
                    ]
                }
            },
            "travel" : {
                name : "Travel",
                icon : "mdi-airplane",
                type : "travel",
                remarks : "Any dream destination in mind? (optional)",
                options : {
                    column1 : [
                        {
                            label : "Airline Tickets",
                            value : "Airline Tickets",
                        },
                        {
                            label : "Hotel / Resort",
                            value : "Hotel / Resort",
                        },
                        {
                            label : "Tour Packages",
                            value : "Tour Packages",
                        },
                        {
                            label : "Cruise Packages",
                            value : "Cruise Packages",
                        },
                        {
                            label : "Visa Assistance",
                            value : "Visa Assistance",
                        },
                        {
                            label : "Passport Assistance",
                            value : "Passport Assistance",
                        },
                        {
                            label : "Travel Insurance",
                            value : "Travel Insurance",
                        },
                        {
                            label : "Transportation Services",
                            value : "Transportation Services",
                        },
                    ],
                    column2 : []
                }
            },
            "celebration" : {
                name : "Celebration / Event",
                icon : "mdi-cake-variant",
                type : "celebration",
                remarks : "Tell us more about your event (optional)",
                options : {
                    column1 : [
                        {
                            label : "Event Venue",
                            value : "Event Venue",
                        },
                        {
                            label : "Catering",
                            value : "Catering",
                        },
                        {
                            label : "Event Styling",
                            value : "Event Styling",
                        },
                        {
                            label : "Host / Emcee",
                            value : "Host / Emcee",
                        },
                        {
                            label : "Entertainment",
                            value : "Entertainment",
                        },
                        {
                            label : "LED Wall & Production",
                            value : "LED Wall & Production",
                        },
                        {
                            label : "Lights & Sounds",
                            value : "Lights & Sounds",
                        },
                        {
                            label : "Live Streaming",
                            value : "Live Streaming",
                        },
                        {
                            label : "Event Photographer",
                            value : "Event Photographer",
                        },
                        {
                            label : "Event Videographer",
                            value : "Event Videographer",
                        },
                        {
                            label : "Souvenirs & Giveaways",
                            value : "Souvenirs & Giveaways",
                        },
                        {
                            label : "Event Coordinator",
                            value : "Event Coordinator",
                        },
                        {
                            label : "Travel Packages for Guests",
                            value : "Travel Packages for Guests",
                        }
                    ],
                    column2 : []
                }
            }
        }

        return options[type];
    }
  }
}